import React, { useState, useEffect } from 'react';
import jsPDF from 'jspdf';
import autoTable from 'jspdf-autotable';
import dayjs from 'dayjs';
import '../assets/Roboto-Bold';
import { Button, CircularProgress } from '@mui/material';

(jsPDF as any).API.events.push(["addFonts", function (this: typeof jsPDF.prototype) {
  this.addFont("Roboto-Bold.ttf", "RobotoBold", "normal");
}]);

interface ReceiptPDFProps {
  id: string;
}

const ReceiptPDF: React.FC<ReceiptPDFProps> = ({ id }) => {
  const [receiptData, setReceiptData] = useState<any>(null);
  const [loading, setLoading] = useState(false);

  const fetchReceiptData = async () => {
    setLoading(true);
    const formData = new FormData();
    formData.append("Id", id);

    try {
      const response = await fetch("https://pay.duyu.alter.net.tr/api/Receipt", {
        method: "POST",
        body: formData,
      });
      const data = await response.json();
      setReceiptData(data.result);
      generatePDF(data.result);
    } catch (error) {
      console.error("Rapor alınamadı:", error);
    } finally {
      setLoading(false);
    }
  };

  const generatePDF = (receiptData: any) => {
    if (!receiptData) return;

    const doc = new jsPDF({
      format: "a5",
      orientation: "landscape",
    });

    // 🧾 Başlık: MAKBUZ
    doc.setFontSize(16);
    doc.setFont("RobotoBold", "normal");
    doc.setTextColor(0);
    doc.text("MAKBUZ", doc.internal.pageSize.getWidth() / 2, 8, { align: "center" });

    doc.setFont("RobotoBold", "normal");

    const formattedDate = dayjs(receiptData.islemTarihi).format('DD.MM.YYYY HH:mm:ss');
    const firmaAdi = receiptData.firmaAdi;
    const tutar = `${Number(receiptData.tutar).toLocaleString("tr-TR")} ₺`;

    // 🟩 Başlık kutusu
    doc.setFontSize(10);
    doc.setFillColor(220, 255, 220);
    doc.rect(10, 10, 190, 20, "F");
    doc.setTextColor(0, 100, 0);
    doc.text(`SAYIN ${firmaAdi}`, 15, 18);
    doc.setFontSize(10);
    doc.setTextColor(50);
    doc.text("Yapmış olduğunuz ödeme için teşekkür ederiz. İşlem bilgileriniz aşağıda bulunmaktadır.", 15, 26);

    // 📄 İşlem Bilgileri
    doc.setFontSize(12);
    doc.setTextColor(0);
    doc.setFont("RobotoBold", "normal");
    doc.text("İşlem Bilgileri", 15, 40);

    autoTable(doc, {
      startY: 45,
      theme: "grid",
      styles: {
        font: "RobotoBold",
        fontSize: 9,
        cellPadding: 3,
      },
      headStyles: {
        fillColor: [242, 242, 242],
        textColor: 0,
        fontStyle: "bold",
      },
      body: [
        ["Firma Adı", firmaAdi],
        ["İşlem Tarihi", formattedDate],
      ],
      margin: { left: 15, right: 15 },
      columnStyles: {
        0: { cellWidth: 50 },
        1: { cellWidth: 120 },
      },
    });

    // 💸 Ödeme Bilgileri
    const finalY = (doc as any).lastAutoTable?.finalY || 60;
    doc.setFont("RobotoBold", "normal");
    doc.text("Ödeme Bilgileri", 15, finalY + 10);

    autoTable(doc, {
      startY: finalY + 15,
      theme: "grid",
      styles: {
        font: "RobotoBold",
        fontSize: 9,
        cellPadding: 3,
      },
      headStyles: {
        fillColor: [242, 242, 242],
        textColor: 0,
        fontStyle: "bold",
      },
      body: [
        ["Ödeme Tutarı", tutar],
        ["Taksit Sayısı", `${receiptData.taksitSayisi}`],
        ["Sanal Pos", receiptData.sanalPos],
      ],
      margin: { left: 15, right: 15 },
      columnStyles: {
        0: { cellWidth: 50 },
        1: { cellWidth: 120 },
      },
    });

    const pdfUrl = doc.output("bloburl");
    window.open(pdfUrl, "_blank");
  };

  return (
    <Button variant="outlined" onClick={fetchReceiptData} disabled={loading}>
      {loading ? <CircularProgress size={24} /> : "Makbuzu Görüntüle"}
    </Button>
  );
};

export default ReceiptPDF;
